import { useQueryClient } from '@tanstack/react-query';
import { Role } from 'auth';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SignUpPagesWrapper } from '@/modules/auth/components/SignUpPagesWrapper.tsx';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { USER_ENTITIES_QUERY_KEY } from '@/modules/entity/queries/entity.tsx';
import { entityPaths } from '@/modules/entity/routes.tsx';
import { Button } from 'ui';
import { CheckBlueIcon } from 'ui/icons';

const VerificationPage = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [params] = useSearchParams();

  const handleBack = () => {
    queryClient.invalidateQueries([USER_ENTITIES_QUERY_KEY]);
    navigate(
      { pathname: entityPaths.static.entityList, search: params.toString() },
      { replace: false },
    );
  };

  return (
    <SignUpPagesWrapper>
      <div className="w-full flex items-center h-full justify-center">
        <div className="max-w-[660px] w-full px-3 sm:px-6  flex flex-col items-center justify-center space-y-10">
          <div className="w-[96px] h-[96px] rounded-[50%] bg-blue-100 flex items-center justify-center">
            <img className="w-[48px] h-[48px]" src={CheckBlueIcon} alt="Loading..." />
          </div>
          <p className="sm:text-[48px] sm:leading-[56px] text-[38px] leading-[46px] font-semibold text-center font-[RecifeDisplay]">
            Your entity verification
            <br /> is in progress
          </p>
          <p className="text-base">We will email you once it's approved.</p>
          <Button className="w-[176px]" onClick={handleBack}>
            Back
          </Button>
        </div>
      </div>
    </SignUpPagesWrapper>
  );
};

export default withPrivateAccess(VerificationPage, Role.SR_INVESTOR);
